import React, { useState } from 'react';
import KazanimSecici from './KazanimSecici';
import KonuDagilimChart from './KonuDagilimChart';
import { HIZLI_ADETLER } from './sabitler';
import { SORU_ADET_MAX } from './yardimcilar';
import { kazanimSozleri } from '../../lib/dersler';

// ============================================================
// KAZANIM(LAR) + ADET (Faz C, 2026-09-03 — kullanıcı kararı: "ders ve kazanım
// bazında soru sayısı esnek konu değerlendirme testleri"). KazanimSecici
// kaskadından seçilen kazanım "+ Ekle" ile listeye girer; her çipte adet.
// Liste boşken tek "Soru sayısı" (dersin tüm kazanımları). Backend sözleşmesi:
// filtre.kazanimDagilimi = [{kazanim_kodu, adet}] (örtüşen prefix'te en özgül
// olan kazanır — MAT.9.2 ve MAT.9.2.1 birlikte seçilebilir).
// ============================================================
export default function KazanimListesi({ apiUrl, ders, mufredat, kazanimlar = [], adet, onDegis, onAdetDegis }) {
  const [secim, setSecim] = useState(null);      // {kod, ad}
  const [resetSayac, setResetSayac] = useState(0);
  const toplam = kazanimlar.reduce((a, k) => a + (Number(k.adet) || 0), 0);
  const zatenVar = !!(secim && kazanimlar.some(k => k.kod === secim.kod));
  const soz = kazanimSozleri(mufredat);

  const ekle = () => {
    if (!secim || !secim.kod || zatenVar) return;
    onDegis([...kazanimlar, {
      kod: secim.kod,
      ad: secim.ad || secim.kod,
      // İlk kazanım mevcut soru sayısını alır; sonrakiler 5'er (öğretmen düzeltir).
      adet: kazanimlar.length === 0 ? Math.max(1, Number(adet) || 20) : 5,
    }]);
    setSecim(null);
    setResetSayac(n => n + 1);
  };
  const adetYaz = (kod, v) => {
    const n = Math.max(1, Math.min(SORU_ADET_MAX, parseInt(v, 10) || 1));
    onDegis(kazanimlar.map(x => (x.kod === kod ? { ...x, adet: n } : x)));
  };

  return (
    <div className="space-y-2" data-kazanim-listesi>
      <div className="flex items-end gap-2">
        <div className="flex-1 min-w-0">
          <KazanimSecici key={`${ders}|${mufredat}|${resetSayac}`} apiUrl={apiUrl} ders={ders} mufredat={mufredat}
            value={secim?.kod || ''} onChange={() => {}} onSecilenBilgi={setSecim} />
        </div>
        <button type="button" onClick={ekle} disabled={!secim || !secim.kod || zatenVar}
          title={zatenVar ? `Bu ${soz.ad} zaten listede` : `Seçili ${soz.adi} listeye ekle`}
          className="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-xs font-semibold hover:bg-indigo-700 disabled:opacity-40 whitespace-nowrap">
          + Ekle
        </button>
      </div>

      {kazanimlar.length === 0 ? (
        <div className="flex items-center gap-2 flex-wrap bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-2">
          <label className="flex items-center gap-1.5 text-xs" title={`${soz.Ad} seçilmediyse bu kadar soru dersin tüm ${soz.adlarindan} çekilir`}>
            <span className="text-[10px] font-bold text-gray-500 uppercase">Soru sayısı</span>
            <input type="number" min={1} max={SORU_ADET_MAX} value={adet}
              onChange={e => onAdetDegis(Math.max(1, Math.min(SORU_ADET_MAX, parseInt(e.target.value, 10) || 1)))}
              className="w-16 px-2 py-1 rounded border border-gray-300 text-xs text-center" />
          </label>
          {HIZLI_ADETLER.map(n => (
            <button key={n} type="button" onClick={() => onAdetDegis(n)}
              className={`px-2 py-0.5 rounded text-[11px] font-semibold ${Number(adet) === n ? 'bg-blue-600 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-100'}`}>
              {n}
            </button>
          ))}
          <span className="text-[10px] text-gray-500">{soz.Ad} seçilmedi — dersin tüm {soz.adlarindan} çekilir.</span>
        </div>
      ) : (
        <>
          <div className="flex flex-wrap items-center gap-1.5">
            {kazanimlar.map(k => (
              <div key={k.kod} title={k.ad}
                className="konu-chip flex items-center gap-1.5 bg-indigo-50 text-indigo-900 border border-indigo-100 px-2 py-1 rounded-full text-[11px]">
                <span className="font-mono font-semibold">{k.kod}</span>
                {k.ad && k.ad !== k.kod && <span className="max-w-[180px] truncate">{k.ad}</span>}
                <span className="opacity-50">×</span>
                <input type="number" min={1} max={SORU_ADET_MAX} value={k.adet} aria-label={`${k.kod} adet`}
                  onChange={e => adetYaz(k.kod, e.target.value)}
                  className="w-12 px-1 py-0 rounded bg-white text-indigo-900 text-[11px] text-center border border-indigo-200" />
                <button type="button" onClick={() => onDegis(kazanimlar.filter(x => x.kod !== k.kod))}
                  title="Kaldır" className="text-indigo-500 hover:text-red-600 font-bold">✕</button>
              </div>
            ))}
            <span className="text-[11px] text-gray-700 ml-1">toplam <strong>{toplam}</strong> soru</span>
            <button type="button" onClick={() => onDegis([])} className="text-[10px] px-1.5 py-0.5 rounded text-gray-500 hover:bg-gray-100" title="Listeyi boşalt">temizle</button>
          </div>
          {kazanimlar.length > 1 && toplam > 0 && (
            <KonuDagilimChart konular={kazanimlar.map(k => k.kod)}
              sayilari={Object.fromEntries(kazanimlar.map(k => [k.kod, k.adet]))} toplam={toplam} />
          )}
        </>
      )}
    </div>
  );
}
